const hiddenColumnsTables = {
  partos: {
    camDescricao: false
  },
  nascimentos: {
    camDescricao: false,
    catNome: false
  },
  concepcoes: {
    camDescricao: false,
    catNome: false
  },
  desmamesOcorridos: {
    camDescricao: false
  },
  protocolosCadastrados: {
  },
  desmamadosPorSemen: {
  },
  femeasExpostas: {
    idadeMeses: false,
    pesoAtual: false
  },
  animaisProtocolo: {
  },
  usuariosNovidade: {
    usuPro: false,
    usuMaster: false
  },
  usuarios: {
  },
  perdasPreParto: {
    idadeAnoMeses: false,
    peso: false
  },
  novidades: {
  },
}

export default hiddenColumnsTables
